import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "@untitledui/icons"

import { LogCallForm, toLocalInput } from "@/components/calls/log-call-form"
import { AdminLayout } from "@/layouts/admin-layout"
import type {
  Attempt,
  CohortOption,
  DispositionOption,
  LogFormContact,
} from "@/pages/admin/calls/types"
import { adminSchoolCallLogsPath, adminSchoolPath } from "@/routes"

interface Props {
  school: { id: number; name: string; phone: string | null }
  contacts: LogFormContact[]
  dispositions: DispositionOption[]
  reached_options: string[]
  cohorts: CohortOption[]
  terms: { value: string; label: string }[]
  defaults: { salesforce_contact_id: string | null; called_at: string }
  attempt: Attempt
}

/**
 * Log a call by hand (Phase 2). The request commits the call and returns; the
 * Task is written to Salesforce behind it and the card shows where it got to.
 */
export default function AdminSchoolsCallLogsNew({
  school,
  contacts,
  dispositions,
  reached_options,
  cohorts,
  terms,
  defaults,
  attempt,
}: Props) {
  return (
    <AdminLayout>
      <Head title={`Log a call · ${school.name}`} />
      <div className="mx-auto flex max-w-3xl flex-col gap-6 px-4 lg:px-8">
        <Link
          href={adminSchoolPath(school.id)}
          className="text-tertiary hover:text-secondary inline-flex w-max items-center gap-1.5 text-sm font-medium transition-colors"
        >
          <ArrowLeft className="size-4" /> Back to {school.name}
        </Link>
        <header className="flex flex-col gap-1">
          <h1 className="text-display-xs md:text-display-sm text-primary">
            Log a call
          </h1>
          <p className="text-tertiary text-md">
            {school.name}
            {school.phone ? ` · ${school.phone}` : ""}. This would be attempt{" "}
            {attempt.step} of {attempt.of}. The Task lands on the account in
            Salesforce, owned by you.
          </p>
        </header>
        <LogCallForm
          action={adminSchoolCallLogsPath(school.id)}
          paramKey="call_log"
          variant="hand"
          initial={{
            salesforce_contact_id: defaults.salesforce_contact_id ?? "",
            called_at: toLocalInput(defaults.called_at),
          }}
          contacts={contacts}
          dispositions={dispositions}
          reached_options={reached_options}
          cohorts={cohorts}
          terms={terms}
          attempt={attempt}
          submitLabel="Log call"
          cancelHref={adminSchoolPath(school.id)}
        />
      </div>
    </AdminLayout>
  )
}
